import React from "react";
import PropTypes from "prop-types";
import Video from "../../../../../containers/Home/Pages/Video";
import tutosImg from "../../../assets/img/tutos.svg";
import Banniere from "../../../../Banniere/Banniere";
import useWindowDimensions from "../../../../../hook/useWindowDimension";

const Tutos = ({
                   handleOpenNavItem,
                   dataUser,
                   navItem
               }) => {

    const {width} = useWindowDimensions();
    return (
        <>
            <div className={"pepiteInfos-header pepiteInfos-tutos-header"}>
                {width > 599 && <Banniere dataUser={dataUser} navItem={navItem}/>}
                <img src={tutosImg}/>
                <h2 className={"titleMobile1"}>
                    Les<span className={"titleMobile3 nauticus"}> tutos</span>
                </h2>
            </div>
            <div className={"mobile-list-container les-tutos-page list-cases"}>
                <Video
                    handleOpenNavItem={handleOpenNavItem}
                />
            </div>
        </>
    );
};

Tutos.propTypes = {
    handleOpenNavItem: PropTypes.func,
    dataUser: PropTypes.object,
    navItem: PropTypes.string
};

export default Tutos;